export default class Popup {
    static fire(args) {

        const defaults = {
            position: window.innerWidth < 600 ? 'bottom' : 'center',
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-primary btn-outline"
            },
            buttonsStyling: false
        }

        args = {...defaults, ...args};

        // Set button visibility flags based on the provided arguments
        args.showConfirmButton = !!args?.confirmButtonText;
        args.showCancelButton = !!args?.cancelButtonText;

        // Extract and remove URL properties from args
        const {confirmButtonUrl = '', cancelButtonUrl = '', closeButtonUrl = ''} = args;
        delete args.confirmButtonUrl;
        delete args.cancelButtonUrl;
        delete args.closeButtonUrl;

        // Helper function to handle URL actions
        const handleUrlAction = (url) => {
            if (url === 'reload') {
                window.location.reload();
            } else {
                window.location.replace(url);
            }
        }

        // Trigger the Swal popup
        return Swal.fire(args).then((result) => {
            // Handle Confirm Button actions
            if (result.isConfirmed && confirmButtonUrl) {
                handleUrlAction(confirmButtonUrl);
            } else if (result.isDismissed) {
                // Handle Cancel Button actions
                if (result.dismiss === Swal.DismissReason.cancel && cancelButtonUrl) {
                    handleUrlAction(cancelButtonUrl);
                } else if (closeButtonUrl) {
                    //Click Close Button or BackDropt
                    handleUrlAction(closeButtonUrl);
                }
            }

            // Handle Close Button actions
            if (!result.isConfirmed && !result.dismiss && closeButtonUrl) {
                handleUrlAction(closeButtonUrl);
            }
        });
    }

    static success(args = {}) {
        args.icon = args?.icon ?? 'success';
        args.text = args?.text ?? 'Succes';
        return Popup.fire(args);
    }

    static error(args) {
        args.icon = args?.icon ?? 'error';
        args.text = args?.text ?? 'Eroare';
        args.confirmButtonText = args?.confirmButtonText ?? ESR.lang.close
        Popup.fire(args);
    }

    static warning(args) {
        args.icon = args?.icon ?? 'warning';
        args.confirmButtonText = args?.confirmButtonText ?? ESR.lang.close
        Popup.fire(args);
    }


    static delete({title, html, action, id}) {
        Swal.fire({
            title: title,
            html: html,
            position: window.innerWidth < 600 ? 'bottom' : 'center',
            confirmButtonText: ESR.lang.delete,
            cancelButtonText: ESR.lang.close,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-primary btn-outline"
            },
            buttonsStyling: false,
            preConfirm: async () => {
                return await $.ajax({
                    type: "POST",
                    url: ESR.ajaxurl,
                    data: {
                        action: action,
                        security: ESR.nonce,
                        id: id
                    }
                }).done((response) => {
                    if (response?.success) {
                        Popup.success({
                            text: response?.data?.message ?? 'No success message',
                            confirmButtonText: ESR.lang.close,
                            confirmButtonUrl: 'reload'
                        });
                    } else {
                        Popup.error({text: response?.data?.message ?? 'No error message'});
                    }
                }).fail((jqXHR, textStatus, errorThrown) => {
                    Popup.error({text: errorThrown});
                });
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
    }

    static toastSuccess(callback = () => {
    }) {
        return Swal.fire({
            title: 'Succes',
            position: "bottom-end",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
            toast: true
        }).then(callback);
    }
}
